<ng-container *transloco="let t">
  <span *ngIf="displayLicenseMessage">
    <a (click)="layoutService.displayAboutDialog(true)" style="cursor: pointer">{{ t('core.layout.footer.copyright.license') }}</a> - </span
  >&copy; {{ copyrightYear }} {{ companyName }}
</ng-container>
